(() => {
  const header = document.querySelector('[data-ok-header]');
  if (header) {
    const triggers = [...header.querySelectorAll('[data-ok-mega-trigger]')];
    const panels = [...header.querySelectorAll('[data-ok-mega-panel]')];
    let closeTimer = 0;
    const cancelClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = 0;
    };
    const closePanels = () => {
      cancelClose();
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      panels.forEach((panel) => { panel.hidden = true; });
    };
    const openPanel = (trigger) => {
      const panel = header.querySelector(`#${trigger.getAttribute('aria-controls')}`);
      if (!panel) return;
      cancelClose();
      triggers.forEach((item) => item.setAttribute('aria-expanded', String(item === trigger)));
      panels.forEach((item) => { item.hidden = item !== panel; });
    };
    const scheduleClose = () => {
      cancelClose();
      closeTimer = window.setTimeout(() => {
        const active = document.activeElement;
        if (active && (triggers.includes(active) || panels.some((panel) => panel.contains(active)))) return;
        closePanels();
      }, 140);
    };
    const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
        if (willOpen) openPanel(trigger);
        else closePanels();
      });
      trigger.addEventListener('focus', () => openPanel(trigger));
      if (supportsHover) {
        trigger.addEventListener('pointerenter', () => openPanel(trigger));
        trigger.addEventListener('pointerleave', scheduleClose);
      }
    });
    panels.forEach((panel) => {
      if (supportsHover) {
        panel.addEventListener('pointerenter', cancelClose);
        panel.addEventListener('pointerleave', scheduleClose);
      }
    });
    header.addEventListener('focusout', scheduleClose);
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openTrigger = triggers.find((trigger) => trigger.getAttribute('aria-expanded') === 'true');
      closePanels();
      openTrigger?.focus();
    });
    document.addEventListener('click', (event) => { if (!header.contains(event.target)) closePanels(); });

    const mobileToggle = header.querySelector('[data-ok-mobile-toggle]');
    const mobileDrawer = header.querySelector('[data-ok-mobile-drawer]');
    mobileToggle?.addEventListener('click', () => {
      const open = mobileToggle.getAttribute('aria-expanded') !== 'true';
      mobileToggle.setAttribute('aria-expanded', String(open));
      if (mobileDrawer) mobileDrawer.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  document.querySelectorAll('[data-ok-category-tabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
      root.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
    }));
  });
})();
